import {GeneralAction, UserPayload} from '../../../@types/actions';
import {MONITOR_INITIALIZE} from '../../../constants/MonitorConstants';

export const GetInitAction = (userId: string): GeneralAction<UserPayload> => ({
    type: MONITOR_INITIALIZE,
    payload: {userId}
});
